import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <header className="border-b border-neutral-200">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Logo />
          <Link
            to="/"
            className="text-sm font-medium text-neutral-600 hover:text-neutral-900"
          >
            ← Back home
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-4xl font-bold tracking-tight">{title}</h1>
        <div className="mt-8 space-y-3 text-sm leading-relaxed text-neutral-700 [&_h2]:mt-8 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-neutral-900 [&_a]:text-amber-700 hover:[&_a]:underline [&_ul]:my-2 [&_li]:my-1 [&_p]:my-2 [&_strong]:text-neutral-900">
          {children}
        </div>
      </main>
    </div>
  );
}
